var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona_stampa",
    "data-name": "icona stampa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_99",
    "data-name": "Tracciato 99",
    d: "M11.949,3.527h-.383V2.051A2.053,2.053,0,0,0,9.516,0H4.484A2.053,2.053,0,0,0,2.434,2.051V3.527H2.051A2.053,2.053,0,0,0,0,5.578V8.859A2.053,2.053,0,0,0,2.051,10.91h.383V12.77A1.232,1.232,0,0,0,3.664,14h6.672a1.232,1.232,0,0,0,1.23-1.23V10.91h.383A2.053,2.053,0,0,0,14,8.859V5.578A2.053,2.053,0,0,0,11.949,3.527Zm-8.7-1.477A1.232,1.232,0,0,1,4.484.82H9.516a1.232,1.232,0,0,1,1.23,1.23V3.527H3.254ZM10.746,12.77a.411.411,0,0,1-.41.41H3.664a.411.411,0,0,1-.41-.41V8.723h7.492Zm2.434-3.91a1.232,1.232,0,0,1-1.23,1.23h-.383V8.723h.246a.41.41,0,0,0,0-.82H2.188a.41.41,0,0,0,0,.82h.246V10.09H2.051A1.232,1.232,0,0,1,.82,8.859V5.578a1.232,1.232,0,0,1,1.23-1.23h9.9a1.232,1.232,0,0,1,1.23,1.23Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_100",
    "data-name": "Tracciato 100",
    d: "M203.6,353H201.41a.41.41,0,0,0,0,.82H203.6a.41.41,0,0,0,0-.82Z",
    transform: "translate(-195.504 -343.348)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_101",
    "data-name": "Tracciato 101",
    d: "M203.6,417H201.41a.41.41,0,0,0,0,.82H203.6a.41.41,0,0,0,0-.82Z",
    transform: "translate(-195.504 -405.598)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_102",
    "data-name": "Tracciato 102",
    d: "M66.723,193H65.41a.41.41,0,0,0,0,.82h1.313a.41.41,0,0,0,0-.82Z",
    transform: "translate(-63.223 -187.723)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0f6a50d0c8cd24ad32eaddfd9d8b5447.svg";
export { ForwardRef as ReactComponent };